<div class="p-4 md:p-6">
  <!-- Page Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center">
    <mat-icon style="color: #1C593D; margin-right: 8px;">people_alt</mat-icon>
    Segmentación de usuarios
    <span class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ dataSource?.data?.length || 0 }} registros
    </span>
  </h1>
  <span class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mt-2">
    {{ dataSource?.data?.length || 0 }} registros
  </span>

  <!-- Info Metric Cards -->
  <div class="flex justify-center gap-4 mt-5 mb-2 flex-wrap">
    <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 12px; padding: 12px 20px; display: flex; align-items: center; gap: 10px;">
      <mat-icon style="color: #1C593D; font-size: 22px; width: 22px; height: 22px;">trending_up</mat-icon>
      <div>
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Precio Spot</span>
        <span style="font-weight: 800; color: #1e5a3f; font-size: 1.1rem;">{{ spotPrice | currency:'$' }}</span>
      </div>
    </div>
    <div style="background: #eff6ff; border: 1px solid #bfdbfe; border-radius: 12px; padding: 12px 20px; display: flex; align-items: center; gap: 10px;">
      <mat-icon style="color: #2563eb; font-size: 22px; width: 22px; height: 22px;">currency_exchange</mat-icon>
      <div>
        <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Tasa USDT</span>
        <span style="font-weight: 800; color: #1e5a3f; font-size: 1.1rem;">{{ usdtRate | currency:'$' }}</span>
      </div>
    </div>
  </div>

  <!-- Filter Card -->
  <div class="flex justify-center mt-4 mb-6">
    <div class="w-full max-w-4xl bg-white p-6 rounded-xl shadow-lg border border-gray-100">
      <div class="flex items-center gap-2 mb-4">
        <mat-icon style="color: #1C593D; font-size: 20px; width: 20px; height: 20px;">filter_list</mat-icon>
        <span class="text-sm font-semibold" style="color: #1e5a3f;">Filtros de búsqueda</span>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <mat-form-field appearance="outline" class="modern-field w-full">
          <mat-label>Tipo de búsqueda</mat-label>
          <mat-select required [(ngModel)]="selectedFilter">
            <mat-option>Seleccione un filtro</mat-option>
            <mat-option *ngFor="let filter of filters" [value]="filter">
              {{ filterDescriptions[filter] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field w-full" *ngIf="selectedFilter === 'USER_SEGMENTATION'">
          <mat-label>Tipo de usuario</mat-label>
          <mat-select required [(ngModel)]="userSegmentationFilter">
            <mat-option>Seleccione un tipo de usuario</mat-option>
            <mat-option *ngFor="let filter of filtersSegmentation" [value]="filter">
              {{ filterSegmentationDescription[filter] }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="modern-field w-full" *ngIf="selectedFilter !== 'USER_SEGMENTATION'">
          <mat-label>Valor de búsqueda</mat-label>
          <input matInput type="text" [(ngModel)]="searchValue" />
          <button *ngIf="searchValue" matSuffix type="button" (click)="searchValue = ''"
            style="background: none; border: none; cursor: pointer; display: inline-flex; align-items: center; padding: 4px;">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #9ca3af;">close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Action Button -->
      <div class="flex justify-center mt-2">
        <button type="button" (click)="search()"
          style="display: inline-flex; align-items: center; gap: 8px; padding: 10px 36px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.9rem; cursor: pointer; transition: background 0.2s ease;"
          onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
          <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">search</mat-icon>
          Buscar
        </button>
      </div>
    </div>
  </div>

  <!-- Desktop Table -->
  <div class="hidden lg:block" *ngIf="dataSource && dataSource.data.length > 0">
    <div style="background: white; border-radius: 16px; overflow: hidden; border: 1px solid #e5e7eb; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1);">
      <div style="overflow-x: auto; max-height: 65vh;">
        <table mat-table [dataSource]="dataSource" (matSortChange)="sortData($event)" matSort class="w-full">

          <!-- Select -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef style="width: 50px;">
              <mat-checkbox (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()">
              </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row">
              <mat-checkbox (click)="$event.stopPropagation()"
                (change)="$event ? selection.toggle(row) : null"
                [checked]="selection.isSelected(row)">
              </mat-checkbox>
            </td>
          </ng-container>

          <!-- ID -->
          <ng-container matColumnDef="idUsuario">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Id</th>
            <td mat-cell *matCellDef="let row">
              <span class="font-mono font-bold text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800">
                {{ row.usuarioId }}
              </span>
            </td>
          </ng-container>

          <!-- Nombre -->
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Nombre</th>
            <td mat-cell *matCellDef="let row">
              <span class="text-xs font-medium" style="color: #374151;">{{ row.nombre }} {{ row.apellidos }}</span>
            </td>
          </ng-container>

          <!-- Email -->
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
            <td mat-cell *matCellDef="let row">
              <span class="text-xs" style="color: #2563eb;">{{ row.email }}</span>
            </td>
          </ng-container>

          <!-- Tipo Segmentación -->
          <ng-container matColumnDef="tipoSegmentacion">
            <th mat-header-cell *matHeaderCellDef>Tipo Usuario</th>
            <td mat-cell *matCellDef="let row">
              <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
                [style.background]="getSegmentBg(row.segmentacionId)"
                [style.color]="getSegmentColor(row.segmentacionId)">
                {{ getTipoUsuario(row.segmentacionId) }}
              </span>
            </td>
          </ng-container>

          <!-- Puntos Spot -->
          <ng-container matColumnDef="puntosSpot">
            <th mat-header-cell *matHeaderCellDef>Puntos Spot</th>
            <td mat-cell *matCellDef="let row">
              <span class="text-xs font-bold" style="color: #7c3aed;">{{ row.segmentacionUsdtRate }}</span>
            </td>
          </ng-container>

          <!-- Tasa Usuario -->
          <ng-container matColumnDef="tasaUsuario">
            <th mat-header-cell *matHeaderCellDef>Tasa Usuario</th>
            <td mat-cell *matCellDef="let row">
              <span class="text-xs font-bold" style="color: #1e5a3f;">{{ getTasaUsuario(row) | currency:'$' }}</span>
            </td>
          </ng-container>

          <!-- Monto Mínimo Tasa -->
          <ng-container matColumnDef="montoMinimoTasa">
            <th mat-header-cell *matHeaderCellDef>Monto mínimo tasa</th>
            <td mat-cell *matCellDef="let row">
              <div style="display: flex; align-items: center; gap: 4px;">
                <input matInput type="text" [(ngModel)]="row.minimumTresholdUsdt" appOnlynumber matInputCommified
                  [disabled]="row.segmentacionId === 1"
                  style="width: 100px; padding: 6px 8px; border: 1px solid #d1d5db; border-radius: 6px; font-size: 0.8rem; color: #374151; background: white; outline: none;"
                  [style.opacity]="row.segmentacionId === 1 ? '0.4' : '1'" />
                <button *ngIf="row.segmentacionId !== 1" title="Guardar" (click)="updateMinAmount(row)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
                  onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">save</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <!-- Acciones -->
          <ng-container matColumnDef="acciones" stickyEnd>
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let row">
              <div style="display: flex; gap: 4px; justify-content: center;">
                <button title="Configurar" (click)="openUserDialog(row)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bfdbfe; border-radius: 6px; background: #eff6ff; cursor: pointer;"
                  onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">settings</mat-icon>
                </button>
                <button *ngIf="row.segmentacionId !== 1" title="Asignar puntos" (click)="openAssignPoints(row)"
                  style="display: inline-flex; align-items: center; justify-content: center; width: 30px; height: 30px; border: 1px solid #bbf7d0; border-radius: 6px; background: #f0fdf4; cursor: pointer;"
                  onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">swap_vert</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
      </div>
    </div>
  </div>

  <!-- Mobile Cards -->
  <div class="lg:hidden" *ngIf="dataSource && dataSource.data.length > 0">
    <!-- Select All -->
    <div style="display: flex; align-items: center; gap: 8px; padding: 10px 16px; background: white; border-radius: 10px; border: 1px solid #e5e7eb; margin-bottom: 12px;">
      <mat-checkbox (change)="$event ? masterToggle() : null"
        [checked]="selection.hasValue() && isAllSelected()"
        [indeterminate]="selection.hasValue() && !isAllSelected()">
      </mat-checkbox>
      <span style="font-size: 0.8rem; font-weight: 600; color: #374151;">Seleccionar todos</span>
      <span *ngIf="selection.selected.length > 0" class="text-xs font-semibold px-2 py-0.5 rounded-full bg-green-100 text-green-800">
        {{ selection.selected.length }} seleccionados
      </span>
    </div>

    <div class="flex flex-col gap-3">
      <div *ngFor="let row of dataSource.data; let i = index"
        style="background: white; border-radius: 12px; overflow: hidden; transition: all 0.2s ease;"
        [style.border]="expandedCardId === i ? '1.5px solid #1C593D' : '1px solid #e5e7eb'"
        [style.box-shadow]="expandedCardId === i ? '0 4px 12px rgba(28,89,61,0.15)' : '0 1px 3px rgba(0,0,0,0.1)'">

        <!-- Card Header -->
        <div (click)="toggleCard(i)"
          style="display: flex; align-items: center; justify-content: space-between; padding: 12px 16px; cursor: pointer;"
          [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
          <div style="display: flex; align-items: center; gap: 8px; flex: 1; min-width: 0; flex-wrap: wrap;">
            <mat-checkbox (click)="$event.stopPropagation()"
              (change)="$event ? selection.toggle(row) : null"
              [checked]="selection.isSelected(row)">
            </mat-checkbox>
            <span class="font-mono font-bold text-xs px-2 py-0.5 rounded-full bg-green-100 text-green-800">
              #{{ row.usuarioId }}
            </span>
            <span class="px-2 py-0.5 text-xs font-semibold rounded-full"
              [style.background]="getSegmentBg(row.segmentacionId)"
              [style.color]="getSegmentColor(row.segmentacionId)">
              {{ getTipoUsuario(row.segmentacionId) }}
            </span>
            <span class="text-xs font-medium truncate" style="color: #374151;">
              {{ row.nombre }} {{ row.apellidos }}
            </span>
          </div>
          <mat-icon style="color: #6b7280; transition: transform 0.2s ease; margin-left: 8px; flex-shrink: 0;"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card Body -->
        <div *ngIf="expandedCardId === i" style="padding: 0 16px 16px 16px;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 12px;">
            <div style="grid-column: span 2;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Email</span>
              <span style="font-size: 0.85rem; color: #2563eb;">{{ row.email }}</span>
            </div>
            <div>
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Puntos Spot</span>
              <span style="font-weight: 700; font-size: 0.9rem; color: #7c3aed;">{{ row.segmentacionUsdtRate }}</span>
            </div>
            <div>
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block;">Tasa Usuario</span>
              <span style="font-weight: 700; font-size: 0.9rem; color: #1e5a3f;">{{ getTasaUsuario(row) | currency:'$' }}</span>
            </div>
            <div *ngIf="row.segmentacionId !== 1" style="grid-column: span 2;">
              <span style="font-size: 0.7rem; color: #6b7280; font-weight: 600; text-transform: uppercase; display: block; margin-bottom: 6px;">Monto mínimo tasa</span>
              <div style="display: flex; align-items: center; gap: 8px;">
                <input matInput type="text" [(ngModel)]="row.minimumTresholdUsdt" appOnlynumber matInputCommified
                  style="flex: 1; padding: 8px 12px; border: 1px solid #d1d5db; border-radius: 8px; font-size: 0.85rem; color: #374151; background: white; outline: none;" />
                <button type="button" title="Guardar" (click)="updateMinAmount(row)"
                  style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
                  onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
                  <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">save</mat-icon>
                  Guardar
                </button>
              </div>
            </div>
          </div>

          <!-- Card Actions -->
          <div style="display: flex; gap: 8px; margin-top: 14px; padding-top: 14px; border-top: 1px solid #f3f4f6;">
            <button type="button" (click)="openUserDialog(row)"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #eff6ff; color: #2563eb; border: 1px solid #bfdbfe; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#dbeafe'" onmouseout="this.style.background='#eff6ff'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #2563eb;">settings</mat-icon>
              Configurar
            </button>
            <button *ngIf="row.segmentacionId !== 1" type="button" (click)="openAssignPoints(row)"
              style="flex: 1; display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 16px; background: #f0fdf4; color: #16a34a; border: 1px solid #bbf7d0; border-radius: 8px; font-weight: 600; font-size: 0.8rem; cursor: pointer;"
              onmouseover="this.style.background='#dcfce7'" onmouseout="this.style.background='#f0fdf4'">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px; color: #16a34a;">swap_vert</mat-icon>
              Asignar puntos
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="dataSource && !dataSource.data.length"
    style="text-align: center; padding: 40px 20px; background: white; border-radius: 16px; border: 1px solid #e5e7eb; margin-top: 16px;">
    <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db;">person_search</mat-icon>
    <p style="color: #6b7280; font-weight: 500; margin-top: 12px;">No se encontraron usuarios para los filtros seleccionados.</p>
  </div>
</div>
